import classNames from 'classnames';

import { formatFinancialNumber } from '../../util/helpers';

import styles from './FinancialsDivRow.module.scss';

type Props = {
  extraSubData: Array<Array<number | string>>;
  isVisible: boolean;
};

const FinancialsDivSubRow = ({ extraSubData, isVisible }: Props) => (
  <>
    {isVisible && (
    <>
      {extraSubData.map(((row, index) => (
        // eslint-disable-next-line
        <div key={`${row[index]}${index}`} className={styles.row}>
          {row.map((cell, cellIndex) => (
            // eslint-disable-next-line
            <div key={`${cell}${cellIndex}`} className={classNames(styles.cell, styles.extraSubCell)}>{formatFinancialNumber(cell)}</div>
          ))}
        </div>
      )))}
    </>
    )}
  </>
);

export default FinancialsDivSubRow;
